<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <form
      class="form"
      :class="submitting ? 'is-submitting' : ''"
      @submit.prevent="handleSubmit(submit)"
    >
      <div class="form__error" v-if="serverError">{{ serverError }}</div>

      <div class="form__fields">
        <b-vee-input
          rules="required|email"
          type="email"
          :label="$t('Email')"
          v-model="fields.email"
          :placeholder="$t('email@domain.com')"
        />
      </div>

      <div class="u-df u-jcsb u-aic">
        <span @click="handleLoginLinkClick" class="t-link t-link--dark">
          {{ $t("Retroceder para login") }}
        </span>

        <b-button native-type="submit" type="is-primary" size="is-medium">{{
          $t("Entrar")
        }}</b-button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import store from "@/store";

import { ValidationObserver } from "vee-validate";

import BVeeInput from "./buefy-vee-fields/BVeeInput";

export default {
  components: {
    ValidationObserver,
    BVeeInput,
  },

  data() {
    return {
      serverError: null,
      submitting: false,

      fields: {
        email: "",
      },
    };
  },

  methods: {
    handleLoginLinkClick() {
      this.$emit("switchToLogin");
    },

    submit() {
      this.submitting = true;
      this.serverError = null;

      store
        .dispatch("requestPwReset", { ...this.fields })
        .then(() => {
          this.$emit("success");
        })
        .catch((err) => {
          try {
            this.serverError = err.details.messages.email;
          } catch (err) {
            this.serverError = "Erro não definido";
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>